import { gql } from '@apollo/client';

export const CREATE_SUMMARY_FEEDBACK_RANK_AND_NOTE_MATCH_MUTATION = gql`
  mutation createSummaryFeedbackRankAndNoteMatch(
    $contentSnippetSummaryId: Int!
    $note: String
    $questionAnswerId: Int!
    $questionResponseId: Int!
    $rank: Int
  ) {
    summaryFeedback {
      createSummaryFeedbackRankAndNoteMatch: addFeedbackRankAndNoteMatch(
        contentSnippetSummaryId: $contentSnippetSummaryId
        matchResponseId: $questionResponseId
        note: $note
        questionAnswerId: $questionAnswerId
        sort: $rank
      )
    }
  }
`;
